import { MouseEvent as ReactMouseEvent, useCallback, useState } from 'react';

export function useMenu() {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const openMenu = useCallback((event: ReactMouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const closeMenu = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const open = Boolean(anchorEl);

  return [anchorEl, openMenu, closeMenu, open] as const;
}
